import { PropertyModel } from '@apto/models';
import './property-additional-info-card.scss';
var PropertyAdditionalInfoCard = /** @class */ /*@__PURE__*/ (function () {
    function PropertyAdditionalInfoCard() {
    }
    return PropertyAdditionalInfoCard;
}());
export { PropertyAdditionalInfoCard };
